import { useState } from 'react';
import { Plus } from 'lucide-react';
import type { InboundTrackingEntry } from '@/apis/warehouse';
import { TrackingComparisonTable } from '../TrackingComparisonTable';
import { AddInboundTrackingDialog } from '../AddInboundTrackingDialog';

interface Props {
  orderId: string;
  entries: InboundTrackingEntry[];
  assignedSalespersonId?: string | null;
  assignedWarehouseHandlerId?: string | null;
  canAct?: boolean;
}

export function TrackingSection({
  orderId,
  entries,
  assignedSalespersonId,
  assignedWarehouseHandlerId,
  canAct = true,
}: Props) {
  const [addOpen, setAddOpen] = useState(false);
  const [editingEntry, setEditingEntry] = useState<InboundTrackingEntry | null>(null);

  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-black">Inbound Tracking</h2>
        <button
          type="button"
          onClick={() => setAddOpen(true)}
          disabled={!canAct}
          className="flex items-center gap-1 text-sm font-medium text-primary-s500 hover:underline disabled:cursor-not-allowed disabled:opacity-50 disabled:no-underline"
        >
          <Plus size={14} />
          Add Tracking
        </button>
      </div>

      <TrackingComparisonTable orderId={orderId} entries={entries} onEditEntry={setEditingEntry} />

      <AddInboundTrackingDialog
        open={addOpen}
        onOpenChange={setAddOpen}
        orderId={orderId}
        assignedSalespersonId={assignedSalespersonId}
        assignedWarehouseHandlerId={assignedWarehouseHandlerId}
      />
      <AddInboundTrackingDialog
        open={!!editingEntry}
        onOpenChange={(open) => { if (!open) setEditingEntry(null); }}
        orderId={orderId}
        assignedSalespersonId={assignedSalespersonId}
        assignedWarehouseHandlerId={assignedWarehouseHandlerId}
        entry={editingEntry ?? undefined}
      />
    </section>
  );
}
